





































import { CardBlockModalVue } from "fs-pb-vue2/vueModels/cardOperations/CardBlockModalVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox },
})
export default class CardBlockModal extends CardBlockModalVue {
  async mounted() {
    await this.init();
  }
}
